import axios from "axios";
import ArticleCategoryDTO from "../Models/DTOs/ArticleCategoryDTO";
import CountWrapper from "../Models/DTOs/CountWrapper";
import ArticleDTO from "../Models/DTOs/ArticleDTO";

const ARTICLE_API_URL = `${(process.env.REACT_APP_WEB_API_URL ?? "").replace(/\/+$/, "")}/v1/articles`;

export async function GetSingleArticle(id: number, abortController: AbortController): Promise<ArticleDTO> {
    const response = await axios.get<ArticleDTO>(`${ARTICLE_API_URL}/${id}`, {
        signal: abortController.signal,
    });
    return response.data;
}

async function listArticles(
    params: Record<string, string | number | boolean>,
    abortController: AbortController
): Promise<CountWrapper<ArticleDTO>> {
    const response = await axios.get<CountWrapper<ArticleDTO>>(ARTICLE_API_URL, {
        params: { order: "desc", orderBy: "releasedate", ...params },
        signal: abortController.signal,
    });
    return response.data;
}

export function GetArticlesByCategory(
    categoryId: number,
    skip: number,
    take: number,
    abortController: AbortController,
    excludeIds: number[] = []
) {
    return listArticles({ categoryId, skip, take, ...exclusions(excludeIds) }, abortController);
}

export async function GetArticleCategoryInfo(categoryId: number, abortController: AbortController): Promise<ArticleCategoryDTO> {
    const response = await axios.get<ArticleCategoryDTO>(`${ARTICLE_API_URL}/categories/${categoryId}`, {
        signal: abortController.signal,
    });
    return response.data;
}

export async function GetCategories(abortController: AbortController): Promise<CountWrapper<ArticleCategoryDTO>> {
    const response = await axios.get<CountWrapper<ArticleCategoryDTO>>(`${ARTICLE_API_URL}/categories`, {
        signal: abortController.signal,
    });
    return response.data;
}

export function GetLatestArticles(take: number, skip: number, abortController: AbortController) {
    return listArticles({ take, skip }, abortController);
}

export function GetRelatedArticles(
    categoryId: number,
    excludeId: number,
    releasedBefore: string,
    take: number,
    abortController: AbortController
) {
    return listArticles({ categoryId, excludeId, releasedBefore, take }, abortController);
}

function exclusions(ids: number[]): Record<string, string> {
    const unique = Array.from(new Set(ids)).slice(-100);
    return unique.length ? { excludeIds: unique.join(",") } : {};
}

export function GetLatestStaffPick(
    abortController: AbortController,
    categoryId?: number
) {
    return listArticles({
        take: 1,
        skip: 0,
        orderBy: "releasedate",
        order: "desc",
        ickonicPick: true,
        ...(categoryId === undefined ? {} : { categoryId }),
    }, abortController);
}